'use strict';
var alphabet = require('./alphabet');

/**
 * Decode the id to get the version and worker
 * Mainly for debugging and testing.
 * @param id - the shortid-generated id.
 */
function decode(id) {
    var characters = alphabet.shuffled();
    return {
        version: characters.indexOf(id.substr(0, 1)) & 0x0f,
        worker: characters.indexOf(id.substr(1, 1)) & 0x0f
    };
}

module.exports = decode;



//////////////////
// WEBPACK FOOTER
// ./~/shortid/lib/decode.js
// module id = 468
// module chunks = 4 6 7 8 9 10 12 19 21 22 24 27 55 56